import posthog from 'posthog-js'

let initialized = false

export function initPostHog() {
  if (initialized) return
  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) return

  posthog.init(key, {
    // Same-origin proxy mounted at /metrics (api/Controllers/PostHogProxyController.cs).
    // Override via VITE_POSTHOG_HOST when developing without the .NET host.
    api_host: import.meta.env.VITE_POSTHOG_HOST || '/metrics',
    persistence: 'memory',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    disable_surveys: true,
    ip: false,
    respect_dnt: true,
    advanced_disable_decide: true,
    advanced_disable_feature_flags: true,
  })
  initialized = true
}

export function captureEvent(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return
  posthog.capture(event, properties)
}

export { posthog }
